import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

/**
 * Product-agnostic star rating widget. Renders `max` stars with `value` of them
 * filled. Optional `tooltip` text is shown on hover.
 */
@Component({
  selector: 'ui-star-rating',
  standalone: true,
  imports: [MatTooltipModule],
  templateUrl: './star-rating.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StarRatingComponent {
  readonly value = input.required<number>();
  readonly max = input<number>(5);
  readonly tooltip = input<string>('');

  /** One boolean per star: true = filled. */
  protected readonly stars = computed(() => {
    const filled = Math.round(this.value());
    return Array.from({ length: this.max() }, (_, i) => i < filled);
  });
}
